export default {
  overview: {
    title: "Maschinen Übersicht",
    archive_title: "Archivierte Maschinen",
    subtitle: "Auflistung aller Maschinen.",
    actions: {
      create_new: "Neue Maschine erstellen",
    },
    search: {
      placeholder: "bspw. Name",
    },
    table: {
      headers: {
        id: "ID",
        name: "Bezeichnung",
        unit: "Abrechnungseinheit",
        purchasePrice: "Einkaufspreis",
        createdAt: "Erstellt am",
      },
      empty: {
        purchasePrice: "Nicht gesetzt",
      },
    },
  },
  // Verkaufseinheit einer Maschine beim Kunden bzw. im Projekt (LewMachineSellingUnitSelect).
  selling_unit: {
    label: "Verkaufseinheit",
    // Im ⓘ der gesperrten Auswahl.
    locked: "Frei wählbar mit Festpreis. Mit Aufschlag in der Einheit des Einkaufs, bei Woche oder Monat auch pro Tag.",
    // Die Einheit passt nicht zum Einkauf: ein Aufschlag rechnet nicht in sie um.
    not_converting: "Mit Aufschlag nicht umrechenbar: andere Einheit oder Festpreis",
    same_as_machine: "Wie Maschine",
  },
  detail: {
    title: "Maschine Details",
    actions: {
      update: "Speichern",
    },
    tabs: {
      general: "Allgemein",
      purchase: "Einkauf",
      files: "Dateiablage",
      activity: "Protokoll",
    },
    form: {
      name: "Name",
      unit: "Abrechnungseinheit",
      // In Tonnen; wählt beim Mietlieferanten die Transportklasse.
      // Das Eigengewicht für Anlieferung und Abholung, nicht die Tragkraft, die eine Größe wie „bis 10 t“ oft meint.
      weight: "Transportgewicht",
      weight_info:
        "Das Gewicht der Maschine selbst, nicht ihre Tragkraft. Bestimmt beim Lieferanten die Transportklasse.",
      weight_range: "0 bis 1.000 t",
      purchasePrice: "Einkaufspreis",
      purchaseUnit: "Einkaufspreis Einheit",
      note: "Notizen",
      sections: {
        base_data: "Stammdaten",
        purchase: "Einkauf",
        note: "Notiz",
      },
    },
  },
  create: {
    title: "Maschine Anlegen",
    subtitle: "Neue Maschine anlegen.",
  },
  component: {
    autocomplete: {
      noDataText: "Maschine nicht gefunden {value}",
    },
  },
}
